import { useEffect, useRef } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import FilterTree from './FilterTree/FilterTree'
import useFilterTree from './FilterTree/FilterTree.Redux'
import useNavigation from './Navigation.Redux'
import useDrawer from './Drawer.Redux'

const ModernFilterPanel: React.FC = () => {
  const headingRef = useRef<HTMLHeadingElement>(null)
  const { setDisplayFilter } = useNavigation()
  const { toggle: closeDrawer } = useDrawer()
  const { activeFilters, activeBrands, filterTree, filterBrands, changeFilter, toggleBrand } = useFilterTree()
  const activeCount = activeBrands.length + Object.values(activeFilters)
    .reduce<number>((sum, value) => sum + (Array.isArray(value) ? value.length : 1), 0)
  const hasFilters = filterBrands.length > 0 || filterTree.some(filter => filter.options.length > 0)

  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true })
  }, [])

  const clearSelection = () => {
    // Keep the current category/search context and loaded facets intact.
    for (const [filterId, value] of Object.entries(activeFilters)) {
      if (Array.isArray(value)) {
        value.forEach(option => changeFilter('oder', false, Number(filterId), option))
      } else {
        changeFilter('und', false, Number(filterId), value)
      }
    }
    activeBrands.forEach(brand => toggleBrand(false, brand))
  }

  return <Box component='section' aria-label='Produktfilter' sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
    <Box sx={{ px: 2 }}>
      <Button
        color='inherit'
        startIcon={<ArrowBackIcon />}
        onClick={() => setDisplayFilter(false)}
        sx={{ minHeight: 44, px: 0, textTransform: 'none' }}
      >
        Zum Menü
      </Button>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1 }}>
        <Typography component='h2' ref={headingRef} tabIndex={-1} sx={{ fontSize: 24, fontWeight: 600, m: 0 }}>Filter</Typography>
        {activeCount > 0 && <Button
          color='inherit'
          onClick={clearSelection}
          sx={{ minHeight: 44, textTransform: 'none', textDecoration: 'underline' }}
        >
          Zurücksetzen ({activeCount})
        </Button>}
      </Box>
      <Typography sx={{ fontSize: 14, color: 'text.secondary', mb: 1 }}>
        Wähle deine Filter und zeige anschließend die Ergebnisse an.
      </Typography>
    </Box>

    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overscrollBehavior: 'contain', px: 1 }}>
      {hasFilters
        ? <FilterTree closeOnSelect={false} />
        : <Typography sx={{ p: 2, color: 'text.secondary' }}>Für diese Auswahl sind aktuell keine Filter verfügbar.</Typography>
      }
    </Box>

    <Box sx={{
      flexShrink: 0, bgcolor: 'background.paper',
      borderTop: '1px solid', borderColor: 'divider', p: 2,
      pb: 'max(16px, env(safe-area-inset-bottom))',
    }}>
      <Button variant='contained' fullWidth onClick={closeDrawer} sx={{ minHeight: 48, borderRadius: 2, textTransform: 'none', fontSize: 16, fontWeight: 600 }}>
        Ergebnisse anzeigen
      </Button>
    </Box>
  </Box>
}

export default ModernFilterPanel
